/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show or hide Boolean operation bodies</h4>

<p>Show or hide the bodies resulting from boolean operations.</p>`;

export default function ShowParasolidTooltip() {
    return h('div', { innerHTML: body });
}
